import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ParcelDetail {
    constructor(doc)
    {
		this.label = null
		this.parcelAreaMeasure = null
		this.parcelDescriptionClassificationType = null
		this.parcelDescriptionClassificationTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.parcelAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:ParcelAreaMeasure");
		this.parcelDescriptionClassificationType = x.getStringElement(doc, "./ns:ParcelDescriptionClassificationType");
		this.parcelDescriptionClassificationTypeOtherDescription = x.getStringElement(doc, "./ns:ParcelDescriptionClassificationTypeOtherDescription");
   }

	 GetClassification() {
		return h.descriptionOrOther(this.parcelDescriptionClassificationType, this.parcelDescriptionClassificationTypeOtherDescription);
	 }
}

export class ParcelIdentification {
    constructor(doc)
    {
		this.label = null
		this.parcelIdentificationType = null
		this.parcelIdentifier = null
		this.parcelIdentifierOwnerName = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.parcelIdentificationType = x.getStringElement(doc, "./ns:ParcelIdentificationType");
		this.parcelIdentifier = x.getStringElement(doc, "./ns:ParcelIdentifier");
		this.parcelIdentifierOwnerName = x.getStringElement(doc, "./ns:ParcelIdentifierOwnerName");
   }
}

export class Parcel {
    constructor(doc)
    {
		this.label = null
		this.parcelDetail = null
		this.parcelIdentifications = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:PARCEL_DETAIL");
		if (node !== null)
				this.parcelDetail = new ParcelDetail(node);
		nodes = x.selectNodes(doc, "./ns:PARCEL_IDENTIFICATIONS/ns:PARCEL_IDENTIFICATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.parcelIdentifications.push(new ParcelIdentification(xn));
			});
		}
   }
	GetParcelIdentifier(type) {
		for (var identifier of this.parcelIdentifications)
				if (identifier.parcelIdentificationType === type)
						return identifier;
		return null;
	}

	GetAPNInfo() {
		var info = [];
		for (var id of this.parcelIdentifications) {
			if (id.parcelIdentificationType === "AssessorUnformattedIdentifier") {
				info.push(id.parcelIdentifier);
		 		info.push(this.parcelDetail.GetClassification());
 				info.push(this.parcelDetail.parcelAreaMeasure.ToString());
			}
			return info;
		}

	}
}
